<fcp-modal
    title="{{ 'ORDER.SELECT_STORES_MODAL.TITLE' | translate }}"
    [size]="displayMode === DisplayMode.Desktop ? 'large' : 'mobile'"
    [id]="modalId"
    [config]="{ id: modalId, disableClose: false, mobileAutoScale: true }"
    [showCloseIcon]="!isRequired || (hasSelectedStores | async)"
>
    <div fcp-modal-content class="stores-modal-container">
        <div class="stores-modal-container-warning">
            <fcp-alert type="critical" size="large" *ngIf="errorMessageNoStoreSelectedVisible | async">
                {{ 'MANAGE_CLARA.CREATE_USER.VALIDATION.STORE' | translate }}
            </fcp-alert>

            <fcp-alert
                type="warning"
                size="large"
                *ngIf="warningMessageEmptyUnselectedStoreVisible | async"
                class="stores-modal-container-warning"
            >
                {{ 'ORDER.SELECT_STORES_MODAL.UNSELECT_STORE_WARNING' | translate }}
            </fcp-alert>
        </div>

        <div class="stores-modal-container-info">
            {{ 'ORDER.SELECT_STORES_MODAL.INFO' | translate }}
            <a
                href="https://help.fashion.cloud/{{
                    languageService.getFAQLanguage()
                }}/articles/8643904-the-multi-store-order-on-fashion-cloud "
                class="stores-modal-container-info-link"
            >
                {{ 'ORDER.SELECT_STORES_MODAL.INFO_LINK' | translate }}
            </a>
        </div>

        <form [formGroup]="searchStoresForm" class="stores-modal-container-search-form">
            <fcp-form-field [width]="'fluid'">
                <fcp-icon fcpFieldPrefix [icon]="['fal', 'magnifying-glass']"></fcp-icon>
                <input
                    formControlName="searchQuery"
                    id="searchQuery"
                    fcpInput
                    placeholder="{{ 'ORDER_SUGGESTIONS.SEARCH_STORE' | translate }}"
                />
            </fcp-form-field>
        </form>
        <div class="stores-modal-container-stores">
            <div class="store-cards-container">
                <div *ngFor="let store of filteredStores | async">
                    <fcp-card [cardType]="'store'" (click)="selectStore(store)" class="store-cards-container-card">
                        <!-- TODO: consider moving the style store-select-indicator--selected to the ui component -->
                        <div
                            fcpStoreCardSelector
                            [ngClass]="{ 'store-select-indicator--selected': store.isSelected }"
                            class="store-select-indicator"
                            data-e2e-hook="store-select-indicator"
                        >
                            <fcp-icon
                                *ngIf="!store.isSelected"
                                class="store-select-indicator-icon"
                                [icon]="['fal', 'plus']"
                            ></fcp-icon>
                            <fcp-icon
                                *ngIf="store.isSelected"
                                class="store-select-indicator-icon"
                                [icon]="['fal', 'check']"
                            ></fcp-icon>
                        </div>
                        <span class="card-placeholder-title" fcpStoreCardTitle>
                            {{ getStoreTitle(store) }}
                        </span>
                        <div fcpStoreCardContent class="card-placeholder-content">
                            <span>
                                {{ getStoreSubtitle(store) }}
                            </span>
                        </div>
                        <ng-container fcpStoreCardFooter *ngLet="numberOfArticlesInStores | async as numberOfArticles">
                            <div *ngIf="numberOfArticles?.[store._id] > 0" class="card-placeholder-footer">
                                <fcp-icon
                                    [icon]="['far', 'shopping-cart']"
                                    class="card-placeholder-footer-icon"
                                ></fcp-icon>
                                {{ numberOfArticles[store._id] }}
                                {{ 'ORDER.SELECT_STORES_MODAL.ITEMS_IN_CART' | translate }}
                            </div>
                        </ng-container>
                    </fcp-card>
                </div>
                <fcp-card cardType="store" (click)="addStore()" class="add-store-card">
                    <div fcpStoreCardTitle class="card-placeholder-add-store">
                        <fcp-icon [icon]="['fas', 'plus']" class="card-placeholder-select-icon"></fcp-icon>
                        <p class="card-placeholder-select-text">
                            {{ 'ORDER.SELECT_STORES_MODAL.ADD_NEW_STORE' | translate }}
                        </p>
                    </div>
                </fcp-card>
            </div>
        </div>
    </div>

    <div
        fcp-modal-actions
        class="fcp-modal-actions"
        [ngClass]="{ 'fcp-modal-actions--mobile': displayMode === DisplayMode.Mobile }"
    >
        <button
            fcp-outlined-button
            data-e2e-hook="store-cancel"
            [disabled]="isRequired && !(hasSelectedStores | async)"
            (click)="cancelSave()"
        >
            {{ 'TEXT_CANCEL' | translate }}
        </button>
        <button fcp-button color="prominent" data-e2e-hook="store-save" (click)="saveStores()">
            {{ 'TEXT_SAVE' | translate }}
        </button>
    </div>
</fcp-modal>

<fc-create-store-dialog modalId="create-store"></fc-create-store-dialog>
